import * as React from "react";
import { Button, Icon, toast, useMedia } from "@axum/ax-design";
import {Order} from "../../../../types/orders/order";
import {orderToOrderIdentifier} from "./interfaces";
import {updateOrderState} from "./fetchers";
import { useConfirm } from "../../../Common/Orders/useConfirm";
import { PHONE_MEDIA } from "../../../Common/Orders/styles";
import { useHeaderMenuAction } from "../../Navigation/HeaderActions";

interface Props {
    orders: Order[];
    total: number;
    requestNewPage: () => void;
}

const cancelTitle = (count: number, total: number) => {
  if (count === 1) return total > 1 ? "¿Cancelar el envío rechazado de esta página?" : "¿Cancelar el envío rechazado?";
  return total > count ? `¿Cancelar los ${count} envíos rechazados de esta página?` : `¿Cancelar los ${count} envíos rechazados?`;
};

const cancelDescription = (count: number, total: number) => {
  const outcome = count === 1 ? "Pasa a Cancelado y ya no se puede reintentar." : "Pasan a Cancelado y ya no se pueden reintentar.";
  const rest = total - count;
  if (rest <= 0) return outcome;
  return `${outcome} ${rest === 1 ? "El otro queda como está" : `Los otros ${rest} quedan como están`}.`;
};

export default (props: Props) => {
  const orderIdentifiers = props.orders
      .map(x => orderToOrderIdentifier(x));
  const { confirm, confirmDialog } = useConfirm();

  const buttonFun = (erpState: string): Promise<void> => {
      return updateOrderState(erpState, orderIdentifiers)
          .then(x => {
            if (x.notUpdated > 0) toast.show(x.error, { type: "danger" });
            else toast.show("Actualizado exitosamente", { type: "success" });
            props.requestNewPage();
          });
  }

  const count = orderIdentifiers.length;
  const askCancel = () => confirm({
    title: cancelTitle(count, props.total),
    description: cancelDescription(count, props.total),
    confirmLabel: count === 1 ? "Cancelar envío" : `Cancelar ${count} envíos`,
    tone: "warning",
    run: () => buttonFun("CANCELADO"),
  });

  const phone = useMedia(PHONE_MEDIA);
  useHeaderMenuAction("cancel-all", phone ? {
    label: "Cancelar todos",
    icon: <Icon name="ban" />,
    className: "o360-menu-warning",
    disabled: count === 0,
    onSelect: askCancel,
  } : null);

  return (
      <React.Fragment>
        {!phone && (
          <Button variant="ghost-warning" disabled={count === 0} onClick={askCancel}>
            Cancelar todos
          </Button>
        )}
        <Button variant="primary" disabled={count === 0} onClick={() => buttonFun("REINTENTANDO ENVIO")}>
          <Icon name="repeat" />Reintentar todos
        </Button>
        {confirmDialog}
      </React.Fragment>
  );
};
